import { Component } from '@angular/core';

@Component({
  selector: 'app-cards5-examples-33',
  templateUrl: './cards5-examples-33.component.html'
})
export class Cards5Examples33Component {}
